<template>
  <div class="contact-page">
    <div class="page-body">
      <div class="contact-header">
        <h1>{{ $t('view.contact.title') }}</h1>
        <p>{{ $t('view.contact.subtitle') }}</p>
      </div>

      <div class="contact-card">
        <!-- 类型选择 -->
        <div class="type-row">
          <div
            v-for="t in types"
            :key="t.value"
            :class="['type-chip', { active: form.type === t.value }]"
            @click="form.type = t.value"
          >
            <span class="type-icon">{{ t.icon }}</span>
            <span class="type-label">{{ t.label }}</span>
          </div>
        </div>

        <el-form ref="form" :model="form" :rules="rules" size="medium" class="contact-form">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item prop="name">
                <el-input v-model="form.name" :placeholder="$t('view.contact.phName')" prefix-icon="el-icon-user" maxlength="32" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="email">
                <el-input v-model="form.email" :placeholder="$t('view.contact.phEmail')" prefix-icon="el-icon-message" maxlength="128" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="content">
            <el-input v-model="form.content" type="textarea" :rows="6" :placeholder="$t('view.contact.phContent')" maxlength="1000" show-word-limit />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="submitting" @click="submit" size="medium" class="submit-btn">{{ $t('view.contact.submit') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'Contact',
  data() {
    return {
      form: { type: 'other', name: '', email: '', content: '' },
      submitting: false
    }
  },
  computed: {
    types() {
      return [
        { label: this.$t('view.contact.typeAd'), value: 'ad', icon: '📢' },
        { label: this.$t('view.contact.typeTool'), value: 'tool', icon: '🔧' },
        { label: this.$t('view.contact.typeCooperation'), value: 'cooperation', icon: '🤝' },
        { label: this.$t('view.contact.typeOther'), value: 'other', icon: '💬' }
      ]
    },
    rules() {
      return {
        name: [{ required: true, message: this.$t('view.contact.ruleName'), trigger: 'blur' }],
        email: [
          { required: true, message: this.$t('view.contact.ruleEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('view.contact.ruleEmailInvalid'), trigger: 'blur' }
        ],
        content: [{ required: true, message: this.$t('view.contact.ruleContent'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        request({ url: '/api/pub/contact/submit', method: 'post', data: this.form })
          .then(() => {
            this.$message.success(this.$t('view.contact.submitSuccess'))
            this.reset()
          })
          .catch(() => { this.$message.error(this.$t('view.contact.submitFail')) })
          .finally(() => { this.submitting = false })
      })
    },
    reset() {
      this.$refs.form.resetFields()
      this.form.type = 'other'
    }
  }
}
</script>

<style scoped>
.contact-page { background: #f0f2f8; min-height: calc(100vh - 64px - 60px); }
.page-body { max-width: 560px; margin: 0 auto; padding: 56px 20px 80px; }

.contact-header { text-align: center; margin-bottom: 32px; }
.contact-header h1 { font-size: 30px; font-weight: 800; color: #1a1f36; margin: 0 0 10px; }
.contact-header p { font-size: 14px; color: #8892a6; margin: 0; line-height: 1.6; }

.contact-card {
  background: #fff; border-radius: 16px; padding: 32px; border: 1px solid #ebeef5;
}

.type-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; margin-bottom: 28px; }
.type-chip {
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  padding: 14px 8px; border-radius: 12px; border: 2px solid #e8ebf0;
  cursor: pointer; transition: all .2s; background: #fafbfc;
}
.type-chip:hover { border-color: #c8cee0; }
.type-chip.active { border-color: #4e7cff; background: #f0f4ff; }
.type-icon { font-size: 22px; }
.type-label { font-size: 12px; color: #606266; font-weight: 500; }
.type-chip.active .type-label { color: #4e7cff; }

.contact-form >>> .el-input__inner { border-radius: 8px; }
.contact-form >>> .el-textarea__inner { border-radius: 8px; font-size: 14px; }
.submit-btn { width: 100%; height: 48px; font-size: 15px; border-radius: 10px; }

@media (max-width: 480px) {
  .type-row { grid-template-columns: repeat(2, 1fr); }
  .contact-card { padding: 20px; }
}
</style>
